var NFT_LIST_TYPE_OPTIONS = [{
  value: '',
  label: 'ALL NFTs'
}, {
  value: 'image',
  label: 'IMAGE NFTs'
}, {
  value: 'css',
  label: 'CSS THEMES'
}, {
  value: 'js',
  label: 'EXTENSIONS'
}, {
  value: 'saito-app',
  label: 'Saito Application'
}, {
  value: 'vault-nft-key',
  label: 'ACCESS KEYS'
}];
module.exports = function (ui) {
  var _NFT_LIST_TYPE_OPTION;
  var selected = (ui === null || ui === void 0 ? void 0 : ui.type) || '';
  var selected_label = ((_NFT_LIST_TYPE_OPTION = NFT_LIST_TYPE_OPTIONS.find(function (opt) {
    return opt.value === selected;
  })) === null || _NFT_LIST_TYPE_OPTION === void 0 ? void 0 : _NFT_LIST_TYPE_OPTION.label) || 'ALL NFTs';
  var options = NFT_LIST_TYPE_OPTIONS.map(function (opt) {
    var is_selected = opt.value === selected;
    return "<li class=\"nft-list-type-option\" role=\"option\" data-value=\"".concat(opt.value, "\" aria-selected=\"").concat(is_selected ? 'true' : 'false', "\">").concat(opt.label, "</li>");
  }).join('');
  return "\n    <div class=\"saito-nft-list\">\n\n      <header class=\"saito-overlay-form-header\">\n         <button type=\"button\" id=\"create-nft\" class=\"create-nft-btn saito-button-square\" aria-label=\"Create NFT\"><i class=\"fa-solid fa-plus\" aria-hidden=\"true\"></i></button>\n         <div class=\"nft-list-type\" id=\"nft-list-type\">\n           <button type=\"button\" class=\"nft-list-type-button\" aria-label=\"NFT type\" aria-haspopup=\"listbox\" aria-expanded=\"false\">\n             <span class=\"nft-list-type-label\">".concat(selected_label, "</span>\n             <span class=\"nft-list-type-caret\" aria-hidden=\"true\"></span>\n           </button>\n           <ul class=\"nft-list-type-menu\" role=\"listbox\" hidden>\n             ").concat(options, "\n           </ul>\n         </div>\n      </header>\n\n      <div class=\"nft-list\" id=\"nft-list\">\n        <!-- renderNft() will fill this -->\n      </div>\n\n      <div id=\"nft-list-instructions\" class=\"nft-list-instructions\"></div>\n\n    </div>\n  ");
};